import React from 'react';
import './HomePage.scss'; // Modular SCSS import for Home page
import HomeHero from '../sections/HomeHero/HomeHero';
import HomeFeatures from '../sections/HomeFeatures/HomeFeatures';
import HomeAbout from '../sections/HomeAbout/HomeAbout';
import HomeCTA from '../sections/HomeProducts/HomeCTA';

/**
 * HomePage Component
 * 
 * Pagina principală a site-ului care prezintă o vedere de ansamblu
 * asupra companiei și a serviciilor oferite
 */
const HomePage = () => {
  return (
    <>
      <HomeHero />
      <HomeFeatures />
      <HomeAbout />
      <HomeCTA />
    </>
  );
};

HomePage.propTypes = {};

export default HomePage;
